import { createActions, createReducer } from "reduxsauce"

export const { Types, Creators } = createActions({
  setMetric: ["metric"],
}, {
  prefix: "ompnt/modules/compareFactorSensitivity/",
})

const DEFAULT_STATE = {
  selectedMetric: null,
}
function handleSetMetric(state, { metric }) {
  return { ...state, selectedMetric: metric }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_METRIC]: handleSetMetric,
})
